import i18n from '../i18n';

const FALLBACK_ERROR_KEY = 'common.errorOccurred';

export function getApiErrorMessage(error, fallbackKey = FALLBACK_ERROR_KEY) {
  const code = error?.response?.data?.code;
  if (code) {
    const translationKey = `apiErrors.${code}`;
    const translated = i18n.t(translationKey);
    if (translated && translated !== translationKey) {
      return translated;
    }
  }

  if (error?.response?.data?.errors && Array.isArray(error.response.data.errors)) {
    return error.response.data.errors.map((item) => item.msg).join(', ');
  }

  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message) return error.message;
  return i18n.t(fallbackKey);
}
